import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    submit(event) {
        if (event.isComposing) return

        event.preventDefault()
        this.element.requestSubmit()
    }
}
